import React from 'react';
import HomeComponent from '../components/home';
import { Navigate  } from 'react-router-dom';

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      filters: [],
      chartsList: [],
      chartConfig: [],
      token: sessionStorage.getItem('userToken'),
    }
    this.logout = this.logout.bind(this);
  }
  /**
     * Cierra sesión del usuario y redirige a vista para iniciar sesión.
    */
  logout() {
    sessionStorage.clear();
    this.setState({ redirect: true });
  }

  render() {
    const { theme, timeout } = this.props;
    if (!sessionStorage.getItem('userToken')) {
      return (<Navigate to={'/'} />)
    }
    console.log(window.innerWidth);
    console.log(window.innerHeight);
    return (
      <HomeComponent
        theme={theme}
        logout={this.logout}
        timeout={timeout}
      />
    )
  }
}

export default Home;